import "./widgetInfoContainer.less"

import React from "react";

import {translator} from "core/localization/localization";
import {Window} from 'controls/react/kendoWrappers/window';
import {FormLayout} from 'controls/react/layout/formLayout';
import {Section} from 'controls/react/layout/section';

import SqInfoForm from "../../areas/services/designer/qualifierWizard/subforms/sqInfoForm";
import FieldRow from 'controls/react/fieldRow';

const i18n = translator({
  "Metric information": {
    "no": "Metrikk informasjon",
    "en": "Metric information"
  },
  "Chart settings": {
    "no": "Graf innstillinger",
    "en": "Chart settings"
  }
});

function translateLabels(field) {
	switch (field) {
		case 'accountId':
			return i18n('Account id');
		case 'accountName':
			return i18n('Account name');
		case 'agentId':
			return i18n('Agent id');
		case 'agentName':
			return i18n('Agent Name');
		case 'algorithm':
			return i18n('Algorithm');
		case 'assetId':
			return i18n('Asset Name');
		case 'assetName':
			return i18n('Asset Name');
		case 'breachValue':
			return i18n('Breach value');
		case 'categoryId':
			return i18n('Category id');
		case 'categoryNode':
			return i18n('Category node');
		case 'categoryPath':
			return i18n('Category path');
		case 'categoryText':
			return i18n('Category');
		case 'dataType':
			return i18n('Metric type');
		case 'description':
			return i18n('Description');
		case 'instanceName':
			return i18n('Instance name');
		case 'inverted':
			return i18n('Invert');
		case 'maxValue':
			return i18n('Max value');
		case 'minValue':
			return i18n('Min value');
		case 'metricId':
			return i18n('Metric id');
		case 'metricType':
			return i18n('Metric type');
		case 'monitorName':
			return i18n('Monitor name');
		case 'monitorTypeName':
			return i18n('Monitor Type');
		case 'operator':
			return i18n('Operator');
		case 'persist':
			return i18n('Persist');
		case 'profileText':
			return i18n('Profile');
		case 'registryIdentifier':
			return i18n('Registry identifier');
		case 'registryOwnerId':
			return i18n('Registry owner id');
		case 'registryOwnerName':
			return i18n('Source name');
		case 'registryType':
			return i18n('Registry type');
		case 'ruleTypeText':
			return i18n('Rule type');
		case 'sampleRateText':
			return i18n('Sample rate');
		case 'threshold':
			return i18n('Threshold');
		case 'unitType':
			return i18n('Unit type');
		case 'unitTypeSymbol':
			return i18n('Unit type symbol');
		default:
			return field;
	}
}


export const WidgetInfo = (props) => {
	let chartSettings = props.chartSettings;
	let infoWindowWidth = props.isAnyFlag ? 650 : 450;

	return <Section appearance={"none"}
	                contentPadding={true}
	                contentClass={"widget-info-container"}
	                direction={"row"}
	                width={infoWindowWidth}
	                childrenPadding={true}>
		<Section appearance={'frame'} title={i18n('Metric information')}>
			{props.type === 'request' && <SqInfoForm {...props.data}/>}
			<div>
				{props.type === 'preloaded' && Object.keys(props.data ?? {}).map(field =>
					props.data[field] != null && <FieldRow key={field} label={translateLabels(field)} content={props.data[field]}/>)}
			</div>
		</Section>
		{props.isAnyFlag && <Section appearance={'frame'} title={i18n('Chart settings')}>
			<div>
				{props.flags.hasAggregation && <FieldRow label={i18n('Aggregation')}
				                                              content={chartSettings.aggregationType || 'high'}/>}
				{props.flags.hasChartType && <FieldRow label={i18n('Chart type')}
				                                            content={chartSettings.chartType || 'line'}/>}
				{props.flags.hasMissingData && <FieldRow label={i18n('Ignore missing data')}
				                                              content={JSON.stringify(chartSettings.ignoreMissingData || false)}/>}
				{props.flags.hasRegression && <FieldRow label={i18n('Show trend')}
				                                             content={JSON.stringify(chartSettings.showRegression || false)}/>}
				{props.flags.hasThreshold && <FieldRow label={i18n('Show threshold')}
				                                            content={JSON.stringify(chartSettings.showThreshold || false)}/>}
			</div>
		</Section>}
	</Section>
}

export default class WidgetInfoContainer extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	render() {
		let screenWidth = window.innerWidth;
		let coordinates = this.props.coordinates;
		let infoWindowHeight = 295;
		let infoWindowWidth = this.props.isAnyFlag ? 650 : 450;
		let infoWindowLeft;
		if (coordinates.left + infoWindowWidth < screenWidth) {
			infoWindowLeft = coordinates.left + 30;
		} else {
			infoWindowLeft = coordinates.left - infoWindowWidth - 10;
		}
		let chartSettings = this.props.chartSettings;
		return (
			<Window height={infoWindowHeight}
					width={infoWindowWidth}
					title={false}
					left={infoWindowLeft}
					top={coordinates.top - 30}
					onClose={() => this.onClose()}
					windowRef={this.windowRefSet}>
				<Section appearance={"none"}
				         contentPadding={true}
				         contentClass={"widget-info-container"}
				         direction={"row"}
				         childrenPadding={true}>
					<Section appearance={'frame'} title={i18n('Metric information')}>
						{this.props.type === 'request' && <SqInfoForm {...this.props.data}/>}
						<div>
							{this.props.type === 'preloaded' && Object.keys(this.props.data ?? {}).map(field =>
								this.props.data[field] != null && <FieldRow key={field} label={translateLabels(field)} content={this.props.data[field]}/>)}
						</div>
					</Section>
					{this.props.isAnyFlag && <Section appearance={'frame'} title={i18n('Chart settings')}>
						<div>
							{this.props.flags.hasAggregation && <FieldRow label={i18n('Aggregation')}
																		  content={chartSettings.aggregationType || 'high'}/>}
							{this.props.flags.hasChartType && <FieldRow label={i18n('Chart type')}
																		content={chartSettings.chartType || 'line'}/>}
							{this.props.flags.hasMissingData && <FieldRow label={i18n('Ignore missing data')}
																		  content={JSON.stringify(chartSettings.ignoreMissingData || false)}/>}
							{this.props.flags.hasRegression && <FieldRow label={i18n('Show trend')}
																		 content={JSON.stringify(chartSettings.showRegression || false)}/>}
							{this.props.flags.hasThreshold && <FieldRow label={i18n('Show threshold')}
																		content={JSON.stringify(chartSettings.showThreshold || false)}/>}
						</div>
					</Section>}
				</Section>
			</Window>
		)
	}

	windowRefSet = ref => {
		this.window = ref;

		//remove window header padding to save space
		let container = this.window.wrapper;
		let containerStyle = container.attr('style');
		containerStyle += 'padding-top: 0 !important;';
		container.attr('style', containerStyle);

		//adapt window height to dynamic container height to save space
		let kendoWindow = this.window;
		let actualContainerHeight = kendoWindow.wrapper.find('.section').first().height() + 20;
		let coordinates = this.props.coordinates;
		let screenHeight = window.innerHeight;
		let infoWindowTop;
		if (coordinates.top + actualContainerHeight > screenHeight) {
			infoWindowTop = screenHeight - actualContainerHeight - 10;
		} else {
			infoWindowTop = coordinates.top - 30;
		}
		kendoWindow.setOptions({
			height: actualContainerHeight,
			position: {
				top: infoWindowTop,
				left: kendoWindow.options.position.left
			}
		});

		//remove links, no chance to click since it's shown only on hover
		container.find('.cw_link').removeClass('cw_link');
	}

	componentDidUpdate() {

	}

	onClose = () => {

	}
}
